// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1TJH_","list":"styles_list__1yxTW"};